import React from 'react';
import { Outlet } from 'react-router-dom';

export function LabelListLayout({

}) {
  return <Outlet/>
}

export default LabelListLayout